import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=a7fc3e5a&"
import script from "./Opinion.vue?vue&type=script&lang=js&"
export * from "./Opinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports